// Path: ./src/app/components/EditButtonTopRight/styled.ts
import styled from "styled-components";

export const TagWrapper = styled.div`
  position: relative;
  display: inline-block;
  isolation: isolate;
`;

export const EditButton = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 5;
  opacity: 1;
  transform: none;
  pointer-events: auto;

  .MuiIconButton-root {
    width: 32px;
    height: 32px;
    padding: 4px;
    background: rgba(255, 129, 58, 0.15);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(4px);
    transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
    border: 1px solid rgba(255, 129, 58, 0.35);
  }
  .MuiIconButton-root:hover {
    background: rgba(255, 129, 58, 0.28);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    transform: translateY(-2px);
  }
  .MuiIconButton-root:active {
    transform: translateY(0);
  }
  .MuiIconButton-root:focus-visible {
    outline: 2px solid #ff813a;
    outline-offset: 2px;
  }
`;
